import { useSelector } from "@xstate/store-react";
import { notificationStore } from "./notification-store";

export const useNotificationOpen = () => useSelector(notificationStore, (s) => s.context.open);

export const useNotificationActions = () => ({
  open: () => notificationStore.send({ type: "notification.open" }),
  close: () => notificationStore.send({ type: "notification.close" }),
  toggle: () => notificationStore.send({ type: "notification.toggle" }),
  setOpen: (open: boolean) => notificationStore.send({ type: "notification.setOpen", open }),
});
